// Generated by CoffeeScript 2.6.1

/*
要注意区分当前条目和子条目的 attrs.dataObj[attrs.dataName]
在循环里和循环外是不一样的
*/
var AutoForm, copyObj;

import Box from "./box";

import Notice from "./notice";

import lodash from "lodash";

copyObj = null;

AutoForm = function () {
  var showArr;
  showArr = [];
  return {
    view: function ({ attrs }) {
      var node, nodeType;
      node = attrs.dataObj[attrs.dataName];
      nodeType = Object.prototype.toString.call(node);
      return m("", [
        m("",
          {
            style: {
              display: ["[object Array]",
                "[object Object]"].indexOf(nodeType) !== -1 ? "grid" : void 0,
              gridTemplateColumns: "auto 1fr",
              borderRadius: "1rem"
            }
          },
          [
            (function () {
              //border:"0.1rem solid #ccc"
              switch (nodeType) {
                case "[object Array]":
                case "[object Object]":
                  return Object.entries(node).map(([key,
                    value]) => {
                    return m.fragment([
                      m(Box,
                        {
                          color: "brown"
                        },
                        key),
                      m("",
                        [
                          typeof value === "object" && value !== null ? [
                            m(Box,
                              {
                                isBtn: true,
                                isBlock: false,
                                onclick: () => {
                                  return showArr[key] = !showArr[key];
                                }
                              },
                              showArr[key] ? "收起" : "展开"),
                            showArr[key] ? m(AutoForm,
                              {
                                dataObj: attrs.dataObj[attrs.dataName],
                                dataName: key,
                                extEditMode: attrs.extEditMode
                              }) : void 0
                          ] : m.fragment([
                            m(AutoForm,
                              {
                                dataObj: attrs.dataObj[attrs.dataName],
                                dataName: key,
                                extEditMode: attrs.extEditMode
                              })
                          ])
                        ])
                    ]);
                  });
                case "[object Number]":
                case "[object String]":
                case "[object Null]":
                  return m.fragment([
                    m("",
                      {
                        style: {
                          display: "flex",
                          flexWrap: "wrap"
                        }
                      },
                      [
                        m(Box,
                          {
                            tagName: "textarea",
                            style: {
                              flex: 1,
                              minWidth: "10rem",
                              width: 0
                            },
                            ext: {
                              oninput: (e) => {
                                var base;
                                if ((base = e.target)._valueType == null) {
                                  base._valueType = typeof attrs.dataObj[attrs.dataName];
                                }
                                return attrs.dataObj[attrs.dataName] = e.target.value;
                              },
                              onblur: (e) => {
                                if (e.target._valueType === "number") {
                                  return attrs.dataObj[attrs.dataName] = Number(attrs.dataObj[attrs.dataName]);
                                }
                              },
                              value: attrs.dataObj[attrs.dataName]
                            }
                          }),
                        attrs.dataObj.undo && attrs.dataObj.redo ? m.fragment([
                          m(Box,
                            {
                              isBtn: true,
                              onclick: () => {
                                return attrs.dataObj.undo(attrs.dataName);
                              }
                            },
                            "撤销"),
                          m(Box,
                            {
                              isBtn: true,
                              onclick: () => {
                                return attrs.dataObj.redo(attrs.dataName);
                              }
                            },
                            "还原")
                        ]) : void 0,
                        attrs.extEditMode ? m(Box,
                          {
                            isBtn: true,
                            onclick: () => {
                              delete attrs.dataObj[attrs.dataName];
                              if (Array.isArray(attrs.dataObj)) {
                                return attrs.dataObj.splice(attrs.dataName,
                                  1);
                              }
                            }
                          },
                          "删除") : void 0
                      ])
                  ]);
                case "[object Boolean]":
                  return m.fragment([
                    m(Box,
                      {
                        isSwitch: true,
                        onclick: (a,
                          b,
                          c,
                          _this) => {
                          if (_this.data.value) {
                            return attrs.dataObj[attrs.dataName] = true;
                          } else {
                            return attrs.dataObj[attrs.dataName] = false;
                          }
                        }
                      })
                  ]);
                default:
                  return null;
              }
            }).call(this)
          ]),
        //新增条目
        typeof attrs.dataObj[attrs.dataName] === "object" ? attrs.extEditMode ? m(Box,
          [
            m(Box,
              {
                isBtn: true,
                style:{
                  background:"#7c5d01",
                  color:"#413101",
                },
                onclick: () => {
                  var KeyBox,
                    ValueBox,
                    comp,
                    preSelect;
                  preSelect = "文本";
                  KeyBox = new Box();
                  ValueBox = new Box();
                  comp = function () {
                    return {
                      view: function ({ attrs }) {
                        return m("",
                          [
                            m(Box,
                              {
                                tagName: "select",
                                isBtn: false,
                                noValue: true,
                                ext: {
                                  onchange: (e) => {
                                    return preSelect = e.target.value;
                                  }
                                }
                              },
                              [
                                ["文本",
                                  "数值",
                                  "对象",
                                  "数组"].map((item) => {
                                    return m("option",
                                      {
                                        value: item
                                      },
                                      item);
                                  })
                              ]),
                            m("",
                              {
                                style: {
                                  display: "grid",
                                  gridTemplateColumns: "auto 1fr"
                                }
                              },
                              [
                                Object.prototype.toString.call(attrs.dataObj[attrs.dataName]) !== "[object Array]" ? [
                                  m(Box,
                                    "条目名"),
                                  m(KeyBox,
                                    {
                                      tagName: "input[type=text]"
                                    })
                                ] : void 0,
                                preSelect === "文本" || preSelect === "数值" ? [
                                  m(Box,
                                    "条目值"),
                                  m(ValueBox,
                                    {
                                      tagName: "input[type=text]"
                                    })
                                ] : void 0
                              ])
                          ]);
                      }
                    };
                  };
                  return Notice.launch({
                    content: comp,
                    contentAttrs: attrs,
                    tip: "请选择条目类型",
                    confirm: () => {
                      if (ValueBox.data.value.length === 0) {
                        ValueBox.data.value = (function () {
                          switch (preSelect) {
                            case "文本":
                              return "新增文本";
                            case "数值":
                              return 100;
                          }
                        })();
                      }
                      if (KeyBox.data.value.length === 0) {
                        KeyBox.data.value = `新条目${Date.now()}`;
                      }
                      switch (preSelect) {
                        case "文本":
                        case "数值":
                          switch (Object.prototype.toString.call(attrs.dataObj[attrs.dataName])) {
                            case "[object Array]":
                              attrs.dataObj[attrs.dataName].push(ValueBox.data.value);
                              console.log(attrs.dataObj[attrs.dataName]);
                              break;
                            case "[object Object]":
                              attrs.dataObj[attrs.dataName][KeyBox.data.value] = ValueBox.data.value;
                          }
                          break;
                        case "对象":
                          switch (Object.prototype.toString.call(attrs.dataObj[attrs.dataName])) {
                            case "[object Array]":
                              attrs.dataObj[attrs.dataName].push({});
                              break;
                            case "[object Object]":
                              attrs.dataObj[attrs.dataName][KeyBox.data.value] = {};
                          }
                          break;
                        case "数组":
                          switch (Object.prototype.toString.call(attrs.dataObj[attrs.dataName])) {
                            case "[object Array]":
                              attrs.dataObj[attrs.dataName].push([]);
                              break;
                            case "[object Object]":
                              attrs.dataObj[attrs.dataName][KeyBox.data.value] = [];
                          }
                      }
                      return void 0;
                    }
                  });
                }
              },
              "新增条目"),
            m(Box,
              {
                isBtn: true,
                color: "sliver",
                style:{
                  background:"#6c617a",
                  color:"#36313e",
                },
                onclick: () => {
                  return copyObj = lodash.cloneDeep(attrs.dataObj[attrs.dataName]);
                }
              },
              "复制"),
            copyObj && Object.prototype.toString.call(attrs.dataObj[attrs.dataName]) === "[object Array]" ? m(Box,
              {
                isBtn: true,
                color: "sliver",
                onclick: () => {
                  switch (Object.prototype.toString.call(attrs.dataObj[attrs.dataName])) {
                    case "[object Array]":
                      return attrs.dataObj[attrs.dataName].push(copyObj);
                  }
                }
              },
              "粘贴") : void 0,
            m(Box,
              {
                style:{
                  background:"#636363",
                  color:"#353434",
                },
                isBtn: true,
                onclick: () => {
                  delete attrs.dataObj[attrs.dataName];
                  if (Array.isArray(attrs.dataObj)) {
                    return attrs.dataObj.splice(attrs.dataName,
                      1);
                  }
                }
              },
              "删除本组")
          ]) : void 0 : void 0
      ]);
    }
  };
};

export default AutoForm;
